import React from "react";
import PatternOptionBool from "../PatternOptionBool";

export default props => <PatternOptionBool {...props} name="paperless" />;
